export default {
  "root": "_root_ryo7r_1"
};import "ni:sha-256;p4LdjsbrLo60-pmnPufL5SqiA-9ihTip-aSEs11cQfs";